import React, { useState } from "react";

import MerchantInfoSection from "./SettingSections/MerchantInfoSection";
import CertificatesSection from "./SettingSections/CertificatesSection";
import PagesSection from "./SettingSections/PagesSection";
import BannerSection from "./SettingSections/BannerSection";
import GallerySection from "./SettingSections/GallerySection";
import ChooseUsSection from "./SettingSections/ChooseUsSection";

import { PageLayout } from "./CommonUI";

const SETTING_TABS = [
  {
    id: "merchant-info",
    label: "Merchant Info",
  },
  {
    id: "certificates",
    label: "Certificates",
  },
  {
    id: "gallery",
    label: "Gallery",
  },
  {
    id: "banner",
    label: "Banner",
  },
  {
    id: "choose-us",
    label: "Choose Us",
  },
  {
    id: "pages",
    label: "Pages",
  },
];

export default function ClientSettingsTab({ clientId, clientName }) {
  const [activeTab, setActiveTab] = useState("merchant-info");

  const renderActiveSection = () => {
    switch (activeTab) {
      case "merchant-info":
        return <MerchantInfoSection clientId={clientId} />;

      case "certificates":
        return <CertificatesSection clientId={clientId} />;

      case "gallery":
        return <GallerySection clientId={clientId} />;

      case "banner":
        return <BannerSection clientId={clientId} />;

      case "choose-us":
        return <ChooseUsSection clientId={clientId} />;

      case "pages":
        return <PagesSection clientId={clientId} />;

      default:
        return <MerchantInfoSection clientId={clientId} />;
    }
  };

  return (
    <PageLayout>
      <main className="px-4 py-6">
        {/* Header */}
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-gray-900">
            Website Settings
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Manage website settings for{" "}
            <span className="font-medium text-gray-700">
              {clientName || clientId || "selected client"}
            </span>
          </p>
        </div>

        {/* Tabs */}
        <div className="mb-5 overflow-x-auto rounded-2xl border bg-white p-2">
          <div className="flex min-w-max items-center gap-2">
            {SETTING_TABS.map((tab) => {
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`rounded-xl px-4 py-2.5 text-sm font-medium transition ${
                    isActive
                      ? "bg-[#01C37D] text-white shadow-sm"
                      : "bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Selected tab content */}
        <div>{renderActiveSection()}</div>
      </main>
    </PageLayout>
  );
}
